module.exports = __webpack_public_path__ + "media/a-Ghost-41689dbddd61a5231d643dfe61dbb423.mp3";